(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  /* Desktop shows all footer information. Mobile keeps the touch accordion. */
  const krasnaFooterDetails = document.querySelectorAll('.krasna-footer__accordion');
  const krasnaFooterMobile = window.matchMedia('(max-width: 749px)');
  const setKrasnaFooterState = () => {
    krasnaFooterDetails.forEach((detail) => {
      if (krasnaFooterMobile.matches) {
        detail.removeAttribute('open');
      } else {
        detail.setAttribute('open', '');
      }
    });
  };
  setKrasnaFooterState();
  if (krasnaFooterMobile.addEventListener) {
    krasnaFooterMobile.addEventListener('change', setKrasnaFooterState);
  } else {
    krasnaFooterMobile.addListener(setKrasnaFooterState);
  }

  } catch(e) { console.error(e); }
})();
})();
